export class Login{
//    public email:string;
     public phone:number;
     public password:string;
     sevacategory:any;
}



// WEBPACK FOOTER //
// ./src/models/Login.ts